var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 59,
  height: 28,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 58.5,
  height: 27.5,
  x: 0.25,
  y: 0.25,
  stroke: "#000",
  strokeWidth: 0.5,
  rx: 1.75
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.7,
  d: "m14.65 8.818 3.023 8.571h.12l3.022-8.57h1.293L18.369 19h-1.272L13.358 8.818zM23.536 19v-7.636h1.173V19zm.596-8.91a.83.83 0 0 1-.591-.233.75.75 0 0 1-.244-.562.75.75 0 0 1 .244-.561.83.83 0 0 1 .591-.234q.345 0 .587.234a.74.74 0 0 1 .249.561.74.74 0 0 1-.249.562.82.82 0 0 1-.587.234m5.928 9.07q-1.104 0-1.904-.488a3.27 3.27 0 0 1-1.228-1.372q-.428-.885-.428-2.059 0-1.173.428-2.068.433-.9 1.203-1.402.775-.507 1.81-.507.596 0 1.178.2.581.198 1.059.645.477.443.76 1.174.285.73.284 1.8v.496h-5.887v-1.014h4.694q0-.646-.259-1.153a1.95 1.95 0 0 0-.726-.8q-.467-.294-1.104-.294-.7 0-1.213.348a2.3 2.3 0 0 0-.78.895 2.6 2.6 0 0 0-.274 1.183v.677q0 .864.299 1.466.303.597.84.91.537.308 1.248.308.462 0 .835-.13.378-.133.651-.397.274-.268.423-.666l1.133.318q-.179.578-.601 1.014-.423.433-1.044.677-.622.238-1.397.238m6.677-.16-2.327-7.636h1.233l1.65 5.846h.08l1.63-5.846h1.253l1.611 5.826h.08l1.65-5.826h1.233L42.503 19h-1.154l-1.67-5.866h-.12L37.89 19z"
})));
export { SvgViewButton as ReactComponent };
export default __webpack_public_path__ + "ccdc3fce0ed9c54b3fded4e22f7f6697.svg";